import React from 'react';
import { Button, Container, Text, useBreakpoint, useTheme } from 'basis';
import { OverviewContent } from 'siteContent/overviewContent';
import { ButtonWrapper, HeaderBannerTextStyle, ProductNameWrapper, ProductSubtitle } from './LandingPageGemNz.styles';

const HeaderBannerTextArea = ({ openFeatureAndBenefitsModal }) => {
  const theme = useTheme();
  const breakpoint = useBreakpoint();
  const { headerIntroText, headerText } = OverviewContent.NZV2;

  return (
    <HeaderBannerTextStyle theme={theme}>
      <Container
        padding="0 4 8 4"
        padding-xs="0 6 0 5"
        padding-md="0 0 0 0"
        margin="0"
        margin-md="0 0 0 5"
        margin-lg="0 0 0 5"
        margin-xl="0 0 0 0"
        width="100%"
      >
        <ProductNameWrapper>{headerText}</ProductNameWrapper>
        <ProductSubtitle>
          <Text margin="4 0">{headerIntroText}</Text>
        </ProductSubtitle>
        <ButtonWrapper>
          <Button margin="0 0 8 0" variant="secondary" onClick={openFeatureAndBenefitsModal}>
            {['md', 'lg', 'xl'].includes(breakpoint) ? 'View features and benefits' : 'View features'}
          </Button>
        </ButtonWrapper>
      </Container>
    </HeaderBannerTextStyle>
  );
};

export { HeaderBannerTextArea };
